<template>
  <nav class="navbar navbar-expand-lg navbar-light menu" v-if="!$route.meta.hideMenu">
    <a class="navbar-brand" href="#">
      <img alt="Akdemica" class="logo-menu mr-1" src="../../assets/img/logo-simples.png">
      <img alt="Akdemica" class="logo-menu" src="../../assets/img/tipografia.png">
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="nav-link" to="/">Início</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/cursos">Cursos</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" target="_blank" href="https://play.akdemica.com.br/">
            Meus Cursos
          </a>
        </li>
        <li v-if="user.type == 'TCH' && loggedIn" class="nav-item">
          <router-link
            to="/professor"
            class="nav-link btn btn-outline-secondary btn-sm mx-md-2"
          >
            Painel do Professor
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import TurnIntoTeacher from "./TurnIntoTeacher"

export default {
  components: {
    "turn-into-teacher": TurnIntoTeacher
  },
  computed: {
    ...mapGetters({
      loggedIn: 'getLoggedState',
      user: 'getCurrentUser'
    })
  }
}
</script>
